import { Typography } from '@mui/material'
import { useJsApiLoader, useLoadScript } from '@react-google-maps/api'
import React, { useCallback, useRef } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAccountsAction } from '../../../actions'
import { getCausesList } from '../../../actions/causesAction'
import { getOrderHistory } from '../../../actions/orderActions'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { loginData } from '../../../slices/LoginSlice'
import { mapLoaded } from '../../../slices/mapSlice'
import { TruckAnimation } from '../../animated/TruckAnimation'
import { MainContainer } from '../../containers'
import { SubTitle, Title } from '../../helpers'
import CarouselImages from './CarouselImages'
import { OnGoingService } from './OnGoingService'
import { Products } from './Products'

export const DashBoardContent = () => {
  const { isLoaded } = useLoadScript({ 
    googleMapsApiKey: process.env.REACT_APP_MAPS_API_KEY,
    libraries: ["places"],
  })
  const [ userAuthorization ] = useLocalStorage('login-token', null);
  const { user, isLogin } = useSelector(state => state.login);
  const { data } = useSelector(state => state.accounts)
  const { activeOrders } = useSelector(state => state.order)
  const dispatch = useDispatch();
  const fetchedRef = useRef(false)

  useEffect(() => {
    if(!fetchedRef.current && data.length === 0) {
      fetchedRef.current = true
      // El `finally` libera el ref al terminar: si tuvo éxito, la guarda
      // `data.length === 0` ya evita un refetch; si falló, permite reintentar.
      Promise.all([
        dispatch(getAccountsAction(userAuthorization?.token)),
        dispatch(getCausesList(userAuthorization?.token)),
        dispatch(getOrderHistory(userAuthorization?.token)),
      ]).finally(() => {
        fetchedRef.current = false
      })
      !isLogin && dispatch(loginData(userAuthorization))
      // dispatch(editAccount({editMode: false}))
    }
  }, [])
  useEffect(() => {
    isLoaded && dispatch( mapLoaded(isLoaded))
  }, [isLoaded])
  return (
    <MainContainer>
    <SubTitle text={`Hola ${user?.name}`}/>
    {
      activeOrders?.length > 0 && <OnGoingService />
    }
    <CarouselImages />
    <Products />
    {/* <TruckAnimation /> */}
    </MainContainer>
  )
}
